import { useState } from 'react';
import { BaseNode } from './BaseNode';

export const NoteNode = ({ id, data }) => {
  const [note, setNote] = useState(data?.note || 'Add your notes here...');
  const [color, setColor] = useState(data?.color || '#fef3c7');

  const config = {
    title: 'Note',
    fields: [
      {
        name: 'note',
        type: 'textarea',
        label: 'Note',
        value: note,
        onChange: (e) => setNote(e.target.value),
        placeholder: 'Type your note...',
        rows: 4,
      },
      {
        name: 'color',
        type: 'select',
        label: 'Color',
        value: color,
        onChange: (e) => setColor(e.target.value),
        options: ['#fef3c7', '#fecaca', '#bbf7d0', '#bfdbfe', '#e9d5ff'],
      },
    ],
    handles: [], // No handles - it's just a note!
    width: 250,
    height: 180,
    className: 'shadow-md',
  };

  return (
    <div style={{ backgroundColor: color, borderRadius: '8px' }}>
      <BaseNode id={id} data={data} config={config} />
    </div>
  );
};